import { StatusCode } from 'status-code-enum';

/** Default HTTP error code. */
export const DefaultErrorStatus = StatusCode.ServerErrorInternal;
